<ng-template #totalResultTemplate let-item>
  <app-result-score-cell
    [rfiPercentage]="item.rfiPercentage"
    [rfiWeight]="rfiWeightSum()"
    [rfpPercentage]="item.rfpPercentage"
    [rfpWeight]="rfpWeightSum()"
  />
</ng-template>

<ng-template #reasonTemplate let-item>
  <p-button
    [label]="
      item.decisionReason
        ? ('project.steps.invitationList.reasonShow' | transloco)
        : ('project.steps.invitationList.reasonAdd' | transloco)
    "
    [severity]="item.selection === 'PARTICIPANT' ? 'success' : 'danger'"
    size="small"
    (onClick)="openReasonModal(item)"
    data-testid="decision-reason-btn"
    [disabled]="!item.decisionReason && stepState.isCurrentStepFinished()"
  />
</ng-template>

@if (!isStepPrerequisiteCompleted()) {
  <app-previous-step-incomplete-notice></app-previous-step-incomplete-notice>
} @else {
  <app-invitation-table
    [phaseConfig]="rfdPhaseConfig()"
    [projectId]="projectId"
    (currentPhaseChange)="onCurrentPhaseChange($event)"
  >
    <div header-content class="flex align-items-center gap-2">
      @if (!currentPhase()) {
        <p-button
          icon="pi pi-arrow-left"
          [label]="'project.steps.rfd.invitationList.backToRfp' | transloco"
          [pTooltip]="'project.steps.rfd.invitationList.backToRfpTooltip' | transloco"
          (onClick)="navigateToRfp()"
          styleClass="p-button-outlined"
        ></p-button>
      }
    </div>
  </app-invitation-table>

  <app-decision-reason-modal
    [visible]="reasonModalVisible()"
    [projectId]="projectId"
    [phaseType]="rfdPhaseConfig().phaseType"
    [tool]="selectedReasonTool()"
    (visibleChange)="reasonModalVisible.set($event)"
    [isStepFinished]="stepState.isCurrentStepFinished()"
    (saved)="onReasonSaved($event)"
  />

  <app-rfd-schedule-table [projectId]="projectId" [stepLocked]="isCurrentStepLocked()" />
}
